module.exports = __webpack_public_path__ + "static_pc/img/17.e24ab593.png";